import React from "react";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";

interface PaginationControlProps {
  page: number;
  pageCount: number;
  onChange: (event: React.ChangeEvent<unknown>, newPage: number) => void;
}

export const PaginationControl: React.FC<PaginationControlProps> = ({
  page,
  pageCount,
  onChange,
}) => (
  <Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
    <Pagination
      count={pageCount}
      page={page}
      onChange={onChange}
      color="primary"
    />
  </Box>
);
